// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7b0bae4e","503":"d2002d06"}[chunkId] + ".chunk.js";
};